<app-employee [isMyReport]=true [employeeIndependence]="employeeIndependence"></app-employee>
